import { render, staticRenderFns } from "./classSpecialDetail.vue?vue&type=template&id=44bab8a6&scoped=true"
import script from "./classSpecialDetail.vue?vue&type=script&lang=js"
export * from "./classSpecialDetail.vue?vue&type=script&lang=js"
import style0 from "./classSpecialDetail.vue?vue&type=style&index=0&id=44bab8a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bab8a6",
  null
  
)

export default component.exports